//@flow
import React from 'react';
import { Container } from 'flux/utils';
import ChatActions from '../../Actions/chat';
import Query from '../../Utils/query';
import MediaQuery from 'react-responsive';
import ChatStore from '../../Stores/Chat/chatStore';

type Props = {
  offlineText?:string,
  onlineText?:string,
  onlineTextMobile?:string,
  offlineTextMobile?:string,
  className?:string,
};

type State = {
  chatOnline:boolean,
};

class ZopimLoader extends React.Component<Props, State> {
  static getStores() {
    return [
      ChatStore,
    ];
  }

  static calculateState():State {
    return {
      chatOnline: ChatStore.isChatOnline(),
    };
  }

  static defaultProps = {
    offlineText: 'Help',
    onlineText: 'Contact Us',
    className: 'chat',
  }

  _getChatText() {
    const text = this.state.chatOnline ? this.props.onlineText : this.props.offlineText;
    const mobileText = this.state.chatOnline ? this.props.onlineTextMobile : this.props.offlineTextMobile;

    if (!mobileText) {
      return (<span className="chat-text">{text}</span>);
    }
    return (
      <span className="chat-text">
        <MediaQuery query={Query.toEm({ min: 841 })}>{text}</MediaQuery>
        <MediaQuery query={Query.toEm({ max: 840 })}>{mobileText}</MediaQuery>
      </span>
    );
  }

  _handleChatClick() {
    ChatActions.openChatModal();
  }

  render() {
    if (this.state.chatOnline) {
      return (
        <a href="#" className={this.props.className} onClick={this._handleChatClick}>
          {this._getChatText()}
        </a>
      );
    } else {
      return (
        <a href="https://support.naturebox.com" className={this.props.className}>
          {this._getChatText()}
        </a>
      );
    }
  }
}

export default Container.create(ZopimLoader);
